import {
    Send,
    CheckCircle2,
    Users,
    Zap,
    FileText,
    Sparkles,
    Phone,
    AlertTriangle,
} from "lucide-react";

export const COLOR_CONSTANTS = {
    PRIMARY_BG: "hsl(217,33%,17%)",
    PRIMARY_BG_LIGHT: "hsl(217,33%,25%)",
    ACCENT_GREEN: "hsl(158,48%,38%)",
    ACCENT_GREEN_DARK: "hsl(158,48%,32%)",
    ACCENT_GREEN_TEXT: "hsl(158,45%,55%)",
};

export const STATUS_BADGE_CONFIG = {
    loading: {
        className: "bg-blue-500/20 text-blue-400 border-blue-500/30 text-xs",
        Icon: null,
        label: "Checking...",
        animatingDot: true,
        dotColor: "bg-blue-400",
    },
    error: {
        className: "bg-red-500/20 text-red-400 border-red-500/30 text-xs",
        Icon: AlertTriangle,
        label: "Error",
        animatingDot: false,
    },
    connected: {
        className: "bg-[hsl(158,48%,38%)]/20 text-[hsl(158,45%,55%)] border-[hsl(158,48%,38%)]/30 text-xs",
        Icon: null,
        label: "LIVE",
        animatingDot: true,
        dotColor: "bg-[hsl(158,45%,55%)]",
    },
    pending: {
        className: "bg-amber-500/20 text-amber-400 border-amber-500/30 text-xs",
        Icon: null,
        label: "PENDING",
        animatingDot: false,
    },
};

export const getStatsConfig = (totalSent, totalDelivered, isConnected, deliveryRate = "0") => [
    {
        id: "sent",
        label: "Messages Sent",
        value: isConnected ? totalSent.toString() : "0",
        change: isConnected ? "0%" : "--",
        icon: Send,
        color: "text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-950/50",
        disabled: false,
    },
    {
        id: "delivered",
        label: "Delivered",
        value: isConnected ? totalDelivered.toString() : "0",
        change: isConnected ? `${deliveryRate}%` : "--",
        icon: CheckCircle2,
        color: "text-[#0F6E56] dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-950/50",
        disabled: false,
    },
    {
        id: "contacts",
        label: "Active Contacts",
        value: isConnected ? "0" : "0",
        change: isConnected ? "0%" : "--",
        icon: Users,
        color: "text-purple-600 dark:text-purple-400 bg-purple-50 dark:bg-purple-950/50",
        disabled: true,
    },
    {
        id: "campaigns",
        label: "Campaigns",
        value: isConnected ? "0" : "0",
        change: isConnected ? "This month" : "--",
        icon: Zap,
        color: "text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-orange-950/50",
        disabled: true,
    },
];

export const QUICK_ACTIONS_CONFIG = (isConnected) => [
    {
        id: "send-message",
        title: "Send Message",
        description: "Single messaging",
        icon: Send,
        bgColor: "green",
        hoverBorder: "green-500",
        hoverText: "green-600",
        link: "/whatsapp/send-message",
        enabled: isConnected,
        tooltip: "Connect WhatsApp number first",
    },
    {
        id: "campaigns",
        title: "Campaigns",
        description: "Bulk messaging campaigns",
        icon: Zap,
        bgColor: "blue",
        hoverBorder: "blue-500",
        hoverText: "blue-600",
        link: "/whatsapp/campaigns",
        enabled: false,
        tooltip: "Coming soon",
    },
    {
        id: "templates",
        title: "Templates",
        description: "Manage message templates",
        icon: FileText,
        bgColor: "purple",
        hoverBorder: "purple-500",
        hoverText: "purple-600",
        link: "/whatsapp/templates",
        enabled: isConnected,
        tooltip: "Connect WhatsApp number first",
    },
];

export const HEADER_BUTTONS_CONFIG = {
    applyNow: {
        icon: Sparkles,
        label: "Apply Now",
        className:
            "bg-[hsl(158,48%,36%)] hover:bg-[hsl(158,48%,30%)] text-white font-semibold",
        disabled: true,
        testid: "button-apply-now",
    },
    connect: {
        icon: null, // Will be BsWhatsapp
        label: "Connect with Meta",
        className: "bg-[#1877F2] hover:bg-[#166FE5] text-white font-semibold",
        disabled: false,
        testid: "button-connect-facebook",
    },
    schedule: {
        icon: Phone,
        label: "Schedule Call",
        className: "border-gray-200 text-gray-600 hover:bg-gray-50",
        disabled: true,
        testid: "button-schedule-call",
        variant: "outline",
    },
};

export const QUALITY_RATING_COLOR = {
    GREEN: "bg-green-400",
    AMBER: "bg-amber-400",
    default: "bg-gray-400",
};
